const componentToHex = (color: number) => {
  const result = color.toString(16);
  return result.length == 1 ? '0' + result : result;
};

export const rgbToHex = (r: number, g: number, b: number): string => {
  return '#' + componentToHex(r) + componentToHex(g) + componentToHex(b);
};

export const convertHexColorToGrayScale = (color: string): string => {
  let r = null;
  let g = null;
  let b = null;
  let rgbaSeparated = null;
  const hexSeparated = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(color);
  if (hexSeparated) {
    r = parseInt(hexSeparated[1], 16);
    g = parseInt(hexSeparated[2], 16);
    b = parseInt(hexSeparated[3], 16);
  } else {
    rgbaSeparated = color.match(/[0-9\.]+/g);
    if (rgbaSeparated) {
      r = parseInt(rgbaSeparated[0]);
      g = parseInt(rgbaSeparated[1]);
      b = parseInt(rgbaSeparated[2]);
    }
  }

  if ((!hexSeparated && !rgbaSeparated) || r === null || g === null || b === null) {
    return color;
  }

  let sum = 0;
  sum += r * 0.89;
  sum += g * 1.77;
  sum += b * 0.33;
  const avg = Math.ceil((1.5 * sum) / 3);
  if (hexSeparated) {
    return rgbToHex(avg, avg, avg);
  } else if (rgbaSeparated) {
    return `rgb(${avg},${avg},${avg}${rgbaSeparated[3] ? ',' + rgbaSeparated[3] : ''})`;
  } else {
    return color;
  }
};

export const convertImageToGrayScale = (
  ctx: CanvasRenderingContext2D,
  width: number,
  height: number,
): CanvasRenderingContext2D => {
  const imgPixels = ctx.getImageData(0, 0, width, height);

  for (let y = 0; y < imgPixels.height; y++) {
    for (let x = 0; x < imgPixels.width; x++) {
      const i = y * 4 * imgPixels.width + x * 4;
      const avg = (imgPixels.data[i] * 0.89 + imgPixels.data[i + 1] * 1.77 + imgPixels.data[i + 2] * 0.33) / 3;
      imgPixels.data[i] = avg;
      imgPixels.data[i + 1] = avg;
      imgPixels.data[i + 2] = avg;
    }
  }
  ctx.putImageData(imgPixels, 0, 0, 0, 0, imgPixels.width, imgPixels.height);
  return ctx;
};
